<template>
  <v-dialog v-model="dialogVisible" width="70%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Leaderboard</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <LeaderBoard v-bind:userId="userId" v-bind:leaderBoard="leaderBoard" />
    </v-card>
  </v-dialog>
</template>

<script>
import LeaderBoard from "@/components/LeaderBoard.vue";

export default {
  name: "StudentLeaderBoardDialog",
  components: {
    LeaderBoard,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: "",
    },
    leaderBoard: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    },
  },
};
</script>